module.exports = __webpack_public_path__ + "static/media/iStock-1052892762.50702cd4.jpg";